module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Cooking/Spoon-609cb8dffe591547d06bd7003b03808ff6358875aa53a7868f26213d454cd216.svg";